import React from 'react';
import { Modal, Button, Card, Container } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import CommonCard from '../common/commonCard';
import { useTranslation } from "react-i18next";

function Popup({ show, handleClose, textBody, redirect = true }) {
  const navigate = useNavigate();
    const [t] = useTranslation("login")
  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Body>
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
              <p className="modal-title mb-3">{textBody}</p>
                
                <Button 
                variant="secondary" 
                className='custom-button-primary'
                onClick={() => {
                  handleClose();
                  if(redirect){navigate('/login')}
                }} >
                  {t("popupErrorResetPass.button")}
                </Button>


              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Popup;
